import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryOptions from './baseQueryOptions';

export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery: baseQueryOptions,
  tagTypes: [
    'BankDetails',
    'Contact',
    'Invoice',
    'Invoices',
    'Master',
    'Metrics',
    'Rate',
    'Reminders',
    'Statistics',
    'Template',
    'Templates',
    'Tenant',
    'Tenants',
    'TenantInfo',
    'TenantCompanyInfo',
    'TenantFile',
    'User',
    'UserFeature',
    'Users',
    'Workflows',
  ],
  endpoints: () => ({}),
});
